module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: {
      white: _vm.white
    },
    attrs: {
      "id": "site-header"
    }
  }, [_c('nav', [_c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#section-why-us'),
      expression: "'#section-why-us'"
    }],
    staticClass: "label"
  }, [_vm._v("WHY US")]), _vm._v(" "), _c('div', {
    staticClass: "seperator"
  }, [_vm._v(" > ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#section-work'),
      expression: "'#section-work'"
    }],
    staticClass: "label"
  }, [_vm._v("WORK")]), _vm._v(" "), _c('div', {
    staticClass: "seperator"
  }, [_vm._v(" > ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#section-talking'),
      expression: "'#section-talking'"
    }],
    staticClass: "label"
  }, [_vm._v("TALKING")]), _vm._v(" "), _c('div', {
    staticClass: "seperator"
  }, [_vm._v(" > ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#section-job'),
      expression: "'#section-job'"
    }],
    staticClass: "label"
  }, [_vm._v("JOB")]), _vm._v(" "), _c('div', {
    staticClass: "seperator"
  }, [_vm._v(" > ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#section-qa'),
      expression: "'#section-qa'"
    }],
    staticClass: "label"
  }, [_vm._v("QA")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-076f520c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 664
// module chunks = 0